/** Loose match for a heading: case, spacing and curly apostrophes ignored */
function normalizeHeading(text: string): string {
  return text.replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase()
}

/**
 * The `## ` sections of a markdown document whose headings are in `headings`,
 * in document order, each running up to the next `## ` heading. Sub-headings
 * (`### `) stay inside their section. A trailing `---` divider is dropped, so
 * sections lifted out of a longer page do not end on a stray rule.
 */
export function extractSections(markdown: string, headings: string[]): string {
  const wanted = new Set(headings.map(normalizeHeading))
  const sections: string[] = []
  let current: string[] | null = null

  for (const line of markdown.split(/\r?\n/)) {
    const h2 = /^##\s+(.+?)\s*#*\s*$/.exec(line)
    if (h2 && !line.startsWith('###')) {
      if (current) sections.push(current.join('\n'))
      current = wanted.has(normalizeHeading(h2[1])) ? [line] : null
      continue
    }
    current?.push(line)
  }
  if (current) sections.push(current.join('\n'))

  return sections
    .map(s => s.trimEnd().replace(/\n-{3,}\s*$/, '').trimEnd())
    .join('\n\n')
}
